/**
 * `GET /api/settings` yanıtının şekli.
 *
 * Form şeması İSTEMCİDE ELLE YAZILMAZ — sunucudan gelen `definitions` ile
 * kurulur. snak'ta şema istemcide 17 ayrı dizi hâlinde elle yazılıydı ve
 * sunucuya yeni bir anahtar eklendiğinde panelde sessizce görünmüyordu.
 */

export type SettingType = 'string' | 'text' | 'number' | 'boolean' | 'json' | 'enum';

export interface SettingDefinition {
  type: SettingType;
  default: string;
  area: string;
  secret?: boolean;
  adminOnly?: boolean;
  values?: string[];
  label: string;
  group: string;
  order?: number;
  hint?: string;
}

export interface SettingsResponse {
  /**
   * Her anahtar için string değer. Sır-sınıfı anahtarlar `••••••••` maskesiyle
   * gelir ve yanlarında `<key>_isSet: boolean` bulunur — bu yüzden değer tipi
   * `string | boolean`.
   */
  values: Record<string, string | boolean>;
  definitions: Record<string, SettingDefinition>;
  /** Bölüm sırası. Panelin kendi kopyasını tutmaması için sunucudan gelir. */
  groups: string[];
}

/** Sunucudaki `SECRET_MASK` ile BİREBİR aynı olmak zorunda (sekiz adet U+2022). */
export const SECRET_MASK = '••••••••';
